export { default as getPaymentsActiveMenu } from './getPaymentsActiveMenu';
